import styled from "styled-components";

const FormIntro = styled.p`
  color: ${(props) => props.theme.colors.primary};
  font-weight: ${(props) => props.theme.fontWeight_m};
`;

export default FormIntro;
